export function looksLikeBase64(s: unknown): s is string {
  return (
    typeof s === "string" &&
    // crude check: very long and only base64 chars
    s.length > 100 &&
    /^[A-Za-z0-9+/=]+$/.test(s.replace(/\s+/g, ""))
  );
}

export function base64ToBlobUrl(base64: string, mime = "application/pdf") {
  // If the string already starts with "data:" just return it.
  if (base64.startsWith("data:")) return base64;

  const byteChars = atob(base64);
  const byteNumbers = new Array(byteChars.length)
    .fill(0)
    .map((_, i) => byteChars.charCodeAt(i));
  const byteArray = new Uint8Array(byteNumbers);
  const blob = new Blob([byteArray], { type: mime });
  return URL.createObjectURL(blob);
}
